import { Link } from 'react-router-dom';
import { Calendar, Clock, Tag } from 'lucide-react';
import { getAllBlogPosts } from '../../data/blogPosts';

export default function BlogIndex() {
  const posts = getAllBlogPosts();

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-950">
      <div className="border-b border-gray-200 bg-white dark:border-gray-800 dark:bg-gray-900">
        <div className="container py-12">
          <h1 className="mb-4 text-4xl font-bold text-gray-900 dark:text-gray-50">Blog</h1>
          <p className="text-lg text-gray-600 dark:text-gray-400">
            Perspectives on software engineering, technology, life philosophy, spirituality, and everything in between
          </p>
        </div>
      </div>

      <div className="container py-12">
        <div className="grid gap-8 lg:grid-cols-2">
          {posts.map(post => (
            <Link
              key={post.slug}
              to={`/blog/${post.slug}`}
              className="card group transition-all hover:shadow-lg"
            >
              <div className="mb-4 flex flex-wrap items-center gap-4 text-sm text-gray-600 dark:text-gray-400">
                <span className="flex items-center gap-1">
                  <Calendar size={16} />
                  {new Date(post.date).toLocaleDateString('en-US', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric',
                  })}
                </span>
                <span className="flex items-center gap-1">
                  <Clock size={16} />
                  {post.readingTime}
                </span>
              </div>

              <h2 className="mb-3 text-2xl font-bold text-gray-900 dark:text-gray-50 transition-colors group-hover:text-primary-600 dark:group-hover:text-primary-400">
                {post.title}
              </h2>

              <p className="mb-4 text-gray-700 dark:text-gray-300">{post.excerpt}</p>

              <div className="flex flex-wrap gap-2">
                {post.tags.map(tag => (
                  <span
                    key={tag}
                    className="flex items-center gap-1 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700 dark:bg-primary-950 dark:text-primary-300"
                  >
                    <Tag size={12} />
                    {tag}
                  </span>
                ))}
              </div>

              <div className="mt-4 font-medium text-primary-600 transition-colors group-hover:text-primary-700 dark:text-primary-400 dark:group-hover:text-primary-300">
                Read more →
              </div>
            </Link>
          ))}
        </div>

        {posts.length === 0 && (
          <div className="card text-center">
            <p className="text-gray-600 dark:text-gray-400">No blog posts yet. Check back soon!</p>
          </div>
        )}
      </div>
    </div>
  );
}
